<template>
  <div class="filterable">
    <div class="filterable__panel">
      <input
        v-model="query"
        class="filterable__input"
        type="search"
        :placeholder="placeholder || $t('Filter list')"
        :aria-label="placeholder || $t('Filter list')"
        @input="emitQuery"
      >
      <button
        type="button"
        class="filterable__button button button--default-2 button--icon-only"
      >
        <IconSearch class="icon icon--search" />
        <span>{{ $t('Search') }}</span>
      </button>

      <button
        type="reset"
        class="filterable__close"
        @click="resetQuery"
      >
        <LazyIconClose class="icon icon--close" />
        <span class="visually-hidden">{{ $t('Reset') }}</span>
      </button>
    </div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['filter'])
defineProps<{ placeholder?: string }>()
const query = ref('')

function emitQuery() {
  emit('filter', query.value)
}

function resetQuery() {
  query.value = ''
  emit('filter', query.value)
}
</script>

<style>
@import url("~layers/app/components/Ui/FilterableList.css");
</style>
